export default __webpack_public_path__ + "static/media/Band CT Correct.914fca64.png";